import * as React from 'react';

const MicIcon = ({fillColor = '#fd3c3b', width = '11', height = '11'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 -1 22 20">
    <path
      d="M4.07 21.662a1.354 1.354 0 0 1 0-2.708h2.712v-1.475A8.133 8.133 0 0 1 0 9.482a1.357 1.357 0 0 1 2.714 0 5.425 5.425 0 0 0 10.851 0 1.356 1.356 0 1 1 2.712 0 8.133 8.133 0 0 1-6.782 8v1.475h2.712a1.354 1.354 0 0 1 0 2.708Zm0-12.18V4.068a4.069 4.069 0 1 1 8.137 0v5.414a4.069 4.069 0 0 1-8.137 0Zm2.712-5.414v5.414a1.356 1.356 0 1 0 2.712 0V4.068a1.356 1.356 0 0 0-2.712 0Z"
      fill={fillColor}
    />
  </svg>
);

export default MicIcon;
